import React from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../App";

const ProductCard = ({ product, showAddToCart = true }) => {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.stopPropagation();
    addToCart(product);
  };

  const hasDiscount = product.discount_price && product.discount_price < product.price;
  const discountPercent = hasDiscount 
    ? Math.round((1 - product.discount_price / product.price) * 100) 
    : 0;

  return (
    <div 
      onClick={() => navigate(`/product/${product.id}`)}
      className="group relative bg-zinc-900 overflow-hidden cursor-pointer border border-white/5 hover:border-emerald-500/30 transition-all duration-300"
      data-testid={`product-card-${product.id}`}
    >
      {/* Discount Badge */}
      {hasDiscount && (
        <div className="absolute top-2 left-2 z-10 bg-emerald-500 text-black text-xs font-bold px-2 py-1 rounded-full">
          -{discountPercent}%
        </div>
      )}

      {/* Outlet Badge */}
      {product.is_outlet && (
        <div className="absolute top-2 right-2 z-10 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full">
          OUTLET
        </div>
      )}

      {/* Image */}
      <div className="aspect-square overflow-hidden">
        <img
          src={product.images?.[0] || "https://images.unsplash.com/photo-1760072513403-d70003481414?w=400"}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
      </div>

      {/* Info */}
      <div className="p-4">
        <p className="text-xs text-white/50 uppercase tracking-wider mb-1">{product.category}</p>
        <h3 className="text-sm font-medium text-white line-clamp-1 mb-2">{product.name}</h3>
        
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            {hasDiscount ? (
              <>
                <span className="text-lg font-bold text-emerald-500">€{product.discount_price.toFixed(2)}</span>
                <span className="text-sm text-white/40 line-through">€{product.price.toFixed(2)}</span>
              </>
            ) : (
              <span className="text-lg font-bold text-white">€{product.price.toFixed(2)}</span>
            )}
          </div>

          {showAddToCart && product.is_available && (
            <button
              onClick={handleAddToCart}
              className="w-10 h-10 rounded-full bg-emerald-500 text-black flex items-center justify-center hover:bg-emerald-400 transition-all duration-200 hover:scale-110"
              data-testid={`add-to-cart-${product.id}`}
            >
              <ShoppingBag size={18} />
            </button>
          )}
        </div>

        {!product.is_available && (
          <p className="text-xs text-red-400 mt-2">Non disponibile</p>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
